import { GroupedDayCard } from "./components/day-card/GroupedDayCard";
import { SingleEventCard } from "./components/single-event/SingleEventCard";

export const EventWithModal = ({ arg, isFromJob }) => {
  const isMonthly = arg.view?.type === "dayGridMonth";

  if (!isMonthly) {
    return <SingleEventCard arg={arg} isFromJob={isFromJob} />;
  }

  const { isGroup, date, events } = arg.event.extendedProps || {};

  if (isGroup) {
    return <GroupedDayCard date={date} events={events} />;
  }

  return <SingleEventCard arg={arg} isFromJob={isFromJob} />;
};
